module.exports = __webpack_public_path__ + "static/media/222.c1daa395.jpg";